"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Frosty_OnThirdTurnStartedEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Frosty_OnThirdTurnStartedEventHandlerScript = class Effect_Frosty_OnThirdTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.TurnStarted) {
            return;
        }
        handler.meta.turnCounter = (handler.meta.turnCounter || 0) + 1;
        if (handler.meta.turnCounter < 3) {
            return;
        }
        container.applyDebuff({
            sequence,
            attackerId: handler.args.scriptArgs.frostyApplierId,
            targetId: handler.subject,
            effect: new __1.StunEffectArgs(),
            duration: Duration_1.Duration.Turns(1),
            onAppliedOrResisted: sequence => {
                container.cancelEffect(sequence, handler.args.scriptArgs.frostyEffectId);
            }
        });
    }
};
Effect_Frosty_OnThirdTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Frosty_OnThirdTurnStarted")
], Effect_Frosty_OnThirdTurnStartedEventHandlerScript);
exports.Effect_Frosty_OnThirdTurnStartedEventHandlerScript = Effect_Frosty_OnThirdTurnStartedEventHandlerScript;
